// events
export const EVENT_SENDER_CHANGED = 'bnum-card-item-mail:sender-changed';
export const EVENT_SUBJECT_CHANGED = 'bnum-card-item-mail:subject-changed';
export const EVENT_DATE_CHANGED = 'bnum-card-item-mail:date-changed';
// classes
export const CLASS_MAIN_CONTENT = 'main-content';
export const CLASS_SENDER = 'sender';
export const CLASS_SUBJECT = 'subject';
export const CLASS_DATE = 'date';
// ids
export const ID_SUBJECT_SLOT = 'subjectslot';
export const ID_SENDER_SLOT = 'senderslot';
export const ID_DATE_SLOT = 'dateslot';
export const ID_DATE_ELEMENT_OVERRIDE = 'date-element-override';
// slots
export const SLOT_SENDER_NAME = 'sender';
export const SLOT_SUBJECT_NAME = 'subject';
export const SLOT_DATE_NAME = 'date';
// parts
export const PART_SENDER_OVERRIDE = 'sender-override';
export const PART_SUBJECT_OVERRIDE = 'subject-override';
export const PART_DATE_OVERRIDE = 'date-override';
// data
export const DATA_SUBJECT = 'subject';
export const DATA_SENDER = 'sender';
export const DATA_DATE = 'date';
// attributes
export const ATTRIBUTE_DATA_SUBJECT = `data-${DATA_SUBJECT}`;
export const ATTRIBUTE_DATA_SENDER = `data-${DATA_SENDER}`;
export const ATTRIBUTE_DATA_DATE = `data-${DATA_DATE}`;
export const ATTRIBUTE_READ = 'read';
// states
export const STATE_READ = 'read';
